type FetchResponseText = string;
type FetchResponseBlob = Blob;

const isWindowDefined = () => typeof window !== 'undefined'; 
const getBrowserConstants = () => {
    const G4_DOMAIN = isWindowDefined() 
        ? new URL(window.location.href).hostname.split('.').slice(-2).join('.') 
        : 'geolog4.com'

    return { 
        G4_DOMAIN: process.env.GATSBY_G4_DOMAIN ?? G4_DOMAIN,
        G4_DOMAIN_PROTOCOL: process.env.GATSBY_G4_PROTOCOL ?? 'https',
        BOR_CONVERTER_NAMESPACE: process.env.GATSBY_BOR_CONVERTER_NAMESPACE ?? 'bor-converter'
    };
}

const sendFile = async (url: string, file: File, authToken: string) => {
    const data = new FormData();
    data.append("file", file);
    console.log(authToken)
    const response = await fetch(url, {
        method: 'POST',
        body: data,
        headers: {
            ...(authToken && {authToken})
        }
    });

    if (!response.ok) {
        throw new Error(`POST request error : ${response.statusText}`);
    }
    return response;
};

export async function checkTrial(): Promise<number> {
    const { G4_DOMAIN_PROTOCOL, G4_DOMAIN, BOR_CONVERTER_NAMESPACE } = getBrowserConstants();
    const url = `${G4_DOMAIN_PROTOCOL}://${BOR_CONVERTER_NAMESPACE}.${G4_DOMAIN}/api/convert`;

    try {
        const response = await fetch(url, {
            method: 'OPTIONS',
            headers: new Headers({
                'Accept': '*/*', 
                'Accept-Encoding': 'gzip, deflate, br', 
                'Connection': 'keep-alive', 
                'Content-Type': 'application/json'
            }),
        });
        if (!response.ok && response.status != 429) {
            console.error('Error on checkTrial request:', response.statusText);
            throw new Error(`API request error: ${response.statusText}`);
        }

        const data = await response.json();
        return data.count;
    } catch (error) {
        console.error('Erreur dans checkTrial:', error);
        throw error; 
    }
}

export const api = {
    login: async (email: string, password: string): Promise<{accounts: string[], authToken: string}> => {
    const { G4_DOMAIN_PROTOCOL, G4_DOMAIN } = getBrowserConstants();
    const response = await fetch(`${G4_DOMAIN_PROTOCOL}://${G4_DOMAIN}/users/auth_info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email, password}),
      });

      if (!response.ok) {
        throw new Error(`Error on authentication`);
      }
      return response.json();
    },
    convert: async (file: File, authToken: string) => {
        try {
            const { G4_DOMAIN_PROTOCOL, G4_DOMAIN, BOR_CONVERTER_NAMESPACE } = getBrowserConstants();
            const response = await sendFile(`${G4_DOMAIN_PROTOCOL}://${BOR_CONVERTER_NAMESPACE}.${G4_DOMAIN}/api/convert`, file, authToken);
            
            const contentDisposition = response.headers.get('Content-Disposition');
            if (!contentDisposition) {
                throw new Error("Missing Content-Disposition header");
            }

            let filename;
            const parts = contentDisposition.split(/;(.+)/);
            if (parts[1]) {
                const nameParts = parts[1].split(/=(.+)/);
                filename = nameParts[1];
            }

            if (!filename) {
                throw new Error("Unable to determinate file's name");
            }

            const blob = await response.blob();
            return { file: blob, name: filename.replaceAll("\"", "") };
        } catch (error) {
            throw error;
        }
    },
 
    transfer: async function ({file, name, account}: {file: File | Blob; name: any; account: any; }){
        const { G4_DOMAIN_PROTOCOL, G4_DOMAIN } = getBrowserConstants();
        const apiUrl = `${G4_DOMAIN_PROTOCOL}://${account}.${G4_DOMAIN}/default/api/sync`;
        
        let data = new FormData();
        data.append("name", name);
        data.append("file", file);
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: data,
            mode: "no-cors", 
        });
    
        return await response.text();
 }
};


const postRequest = async (apiUrl: string, file: File , authToken: string): Promise<Response> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
        headers: {
            ...(authToken && {authToken})
        }
  });

    if (!response.ok) {
        throw new Error(`POST request error : ${response.statusText}`);
    }

    return response;
};

export async function previewFile(file: File, authToken: string): Promise<string> {
    const { G4_DOMAIN_PROTOCOL, G4_DOMAIN, BOR_CONVERTER_NAMESPACE } = getBrowserConstants();
    console.log(getBrowserConstants())
    const apiUrl = `${G4_DOMAIN_PROTOCOL}://${BOR_CONVERTER_NAMESPACE}.${G4_DOMAIN}/api/dump`;
    const response = await postRequest(apiUrl, file, authToken);
    return await response.text();
}
